import { Text } from '#pages/DashboardChartForm/components/styles';
import { Input } from '#shared/Input/Input';
import { produce } from 'immer';
import { useDashboardCharFormExerciseState } from '../states/dashboardCharFormExerciseState';

interface ExerciseMemoProps {
  // 해당 인덱스는 ExerciseList 컴포넌트에서 전달받은 운동 리스트의 인덱스.
  // ExerciseList 컴포넌트의 children으로 렌더링될 경우 반드시 있음
  // 타입스크립트 에러를 방지하기 위해 number | undefined로 설정
  index?: number;
}

export const ExerciseMemo = ({ index }: ExerciseMemoProps) => {
  const { records, setRecords } = useDashboardCharFormExerciseState();

  const noIndex = index === undefined;

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (noIndex) return;

    setRecords(
      produce(draft => {
        draft[index].exerciseComment = e.target.value;
      })
    );
  };

  if (noIndex) return <div>no index</div>;

  return (
    <div className="mt-20 flex flex-col gap-8">
      <Text>운동 메모 (선택)</Text>
      <Input
        value={records[index]?.exerciseComment}
        onChange={onChange}
        placeholder="운동에 대한 간단한 메모 작성해주세요"
      />
    </div>
  );
};
